import React from 'react';
import logoFooter from '../../../assets/images/logo/svg/gpo-xcaret-h-logo.svg'
import {mainService} from "../../../jwt/_services";
import {appVersion} from "../../../appData";

class Footer extends React.Component {

  constructor(props) {
    super(props);
    this.state = {
      version: "1.0.0"
    };
  }

  componentDidMount() {
    mainService.getVersion().then(result => {
      if (result != null) {
        this.setState({version: result['appversion']});
      }
    }).catch(_ => {
    });
  }

  render() {
    const {version} = this.state;
    return (
      <footer className="footer text-center">
        <img src={logoFooter} alt={"footer"} />
        <div className="footerText2 text-right">
          Versión : { appVersion }  /  {version}
        </div>
      </footer>
    );
  }
}
export default Footer;
